import { Theme, ThemeOptions } from "@mui/material";

export default function Container(theme: Theme): ThemeOptions["components"] {
  return {
    MuiContainer: {
      styleOverrides: {
        root: {
          border: 'none !important',
          outline: 'none !important'
        }
      }
    }
  };
}